export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6796.1a79b660.jpg";